import { getDateRangeFilter } from 'utils/filter-utils';
import Rest from 'services/data/rest';

export default class Watch extends Rest {
  static path = 'watch';
  static defaultQuery = {
    sort: 'date',
    populate: ['company']
  };

  static mapFilters(filters) {
    const { date, team, ...where } = filters;

    where.date = getDateRangeFilter(date);
    where['company.team'] = team;

    return where;
  }
}
